import Logo from "../components/Logo";

export default function NotFound() {
  return (
    <div className="NotFound">
      <Logo fill="#282c34" height="15rem" />
      <p className="p-4 m-auto">
        404 Not Found
      </p>
    </div>
  );
}
